var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4 12L12 4M12 12L4 4","stroke":"currentColor","stroke-width":"1.33","stroke-linecap":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }